import React, { Component } from 'react';
import { CSVLink, CSVDownload } from "react-csv";
const { tableau } = window;
const arrayObjects = [
  { name: "John", age: 30, location: "New York" },
  { name: "Jane", age: 25, location: "Los Angeles" }
];

// Function to extract key-value pairs based on key names
const extractKeyValue = (array, ...keysToExtract) => {
  return array.map((obj) => {
    const extractedData = {};
    keysToExtract.forEach((key) => {
      extractedData[key] = obj[key];
    });
    return extractedData;
  });
};

// Example usage to extract "name" and "age" keys


function convertToCSV(json) { console.log("ggggggggg"); console.log(json);
      const items = json;
      const replacer = (key, value) => (value === null ? '' : value); // Replace null values with empty strings
      const header = Object.keys(items[0]);
      const csv = [
        header.join(','), // Create CSV header row
        ...items.map((row) => header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(',')), // Create CSV data rows
      ].join('\r\n');

      return csv;
    }

    function downloadCSV(csv, filename) {
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) {
        // For IE and Edge
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }
class TableauEmbed1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //viz:null,
            tableau_worksheet:[],
            project_name:"",
            loading: true,
            underlyingData: [],
            customers_count:"10",
            selectedMarks: [],
            marksData: {},
            selectedMarksData: {},
        }
    }
  componentDidMount() {
  const jsonObjectArray = [
  { "id": 1, "name": "John" },
  { "id": 2, "name": "Jane" },
  { "id": 3, "name": "John" },
  { "id": 4, "name": "Bob" },
  { "id": 2, "name": "Jane" }
];
var lookup = {};
var items = jsonObjectArray;
var result = [];

for (var item, i = 0; item = items[i++];) {
  var name = item.name;

  if (!(name in lookup)) {
    lookup[name] = 1;
    result.push(name);
  }
}

console.log(result);

  const extractedDataArray = extractKeyValue(arrayObjects, "name");
console.log(extractedDataArray);
var nb = "9875564951"
const firstDigit = nb.charAt(0);
const secDigit = nb.charAt(1);
var nm = firstDigit+secDigit+"xxxx"+nb.substr(-4); console.log(nm);
   this.initTableauViz()
const jsonArray = [
  { "  name": "John ", "age ": 30, " location ": "New York", "  first name ": "John " },
  { "  name ": "Jane", " age": 25, "location": " Los Angeles ", "  first name ": "John "  }
];

// Function to remove leading and trailing spaces from the keys of a single object
const removeSpacesFromKeys = (obj) => {
  const newObj = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = key.trim();
      newObj[newKey] = obj[key];
    }
  }
  return newObj;
};

// Function to process the entire JSON array and remove spaces from keys
const removeSpacesFromArray = (arr) => {
  return arr.map(removeSpacesFromKeys);
};

const modifiedJsonArray = removeSpacesFromArray(jsonArray);
console.log("modifiedJsonArray");
console.log(modifiedJsonArray);
// Remove key value pair from json array object
const jsonArray1 = [
  { name: "John", age: 30, location: "New York" },
  { name: "Jane", age: 25, location: "Los Angeles" }
];

const keyToRemove = "age";

// Function to remove a key from a single object
const removeKeyFromObject = (obj, key) => {
  const newObj = { ...obj };
  delete newObj[key];
  return newObj;
};

// Function to process the entire JSON array and remove the specified key from each object
const removeKeyFromArray = (arr, key) => {
  return arr.map((obj) => removeKeyFromObject(obj, key));
};

const modifiedJsonArray1 = removeKeyFromArray(jsonArray1, keyToRemove);
console.log(modifiedJsonArray1);


  }

  initTableauViz = () => {
    const vizDiv = document.getElementById('tableauViz');
    const vizURL = 'https://public.tableau.com/views/RegionalSampleWorkbook/Storms';
    //const vizDiv = this.containerRef;

    const options = {
      width: '40%',
      height: '600px',
      hideTabs: false,
      hideToolbar: true,
      onFirstInteractive: () => {
        this.handleFirstInteractive()
        this.getFilterValues()
      },
    };

    // Create a new Tableau Viz object
    const viz = new tableau.Viz(vizDiv, vizURL, options);
    this.viz = viz;
  };
  exportToPDF(viz) {
    if (this.viz) {
      this.viz.showExportPDFDialog();
    }
  }
//   handleMarksSelection = (event) => {
//     console.log(event.getWorksheet().getName());
//     const selectedMarks = event.getMarksAsync().then((marks) => {
//       console.log("marks")
//       console.log(marks.length);
//       const worksheetName1 = marks.getWorksheet().getName();
//       console.log(worksheetName1);
//       console.log(marks)
//       marks.map((mark, index) => {
//         console.log("markval");
//         console.log(mark.getName());
//         const worksheetName = mark.getWorksheet().getName();
//         console.log("getWorksheet");
//         console.log(mark.getWorksheet());
//         console.log(worksheetName);
//     });
//       this.setState({
//         selectedMarks: marks,
//       });
//     });
//
//     const filterInfo = {};
//
//     tableau.VizManager.getVizs().forEach((viz) => {
//       const worksheet = viz.getWorkbook().getActiveSheet();
//       const filters = worksheet.getFiltersAsync().then((worksheetFilters) => {
//         filterInfo[worksheet.getName()] = worksheetFilters;
//         console.log(filterInfo);
//
//         this.setState({
//           filterInfo: filterInfo,
//         });
//       });
//     });
//   };
  exportToCSV() {
    // Call the showExportCrossTabDialog method on the viz object
    if (this.viz) {
      this.viz.showExportCrossTabDialog();
    }
  }
  showDownloadDialog() {
    // Call the showExportCrossTabDialog method on the viz object
    if (this.viz) {
      this.viz.showDownloadDialog();
    }
  }
  exportData() {
    // Call the showExportCrossTabDialog method on the viz object
    if (this.viz) {
      this.viz.showExportDataDialog();
    }
  }
  getUnderlyingData(e) {
    // Call the getUnderlyingDataAsync method on the viz object
    var that = this;
    if (this.viz) {
         var keyValuesData = [];
         var sheet = this.viz.getWorkbook().getActiveSheet().getWorksheets().get("Storm Map Sheet");
	       // If the active sheet is not a dashboard, then you can just enter:
	       // viz.getWorkbook().getActiveSheet();
         var options = {
            maxRows: 10, // Max rows to return. Use 0 to return all rows
            ignoreAliases: true,
            ignoreSelection: true,
            includeAllColumns: false,

          };
          console.log(sheet);
          sheet.getUnderlyingDataAsync(options).then(function(t){

              var columns = t.getColumns();
              var dataRows = t.getData();
              console.log("hghg");
              console.log(dataRows.length);

              console.log(columns);
              console.log(dataRows);
                 for (var i = 0; i < dataRows.length; i++) {
                      var row = dataRows[i];
                      var keyValueRow = {};
                      for (var j = 0; j < columns.length; j++) {
                        var fieldName = columns[j].getFieldName();
                        var fieldValue = row[j].value;
                        keyValueRow[fieldName] = fieldValue;
                      }
                      keyValuesData.push(keyValueRow);
                    }
                    console.log(keyValuesData);

                  const csv = convertToCSV(keyValuesData);
                  const filename = 'data.csv';
                  downloadCSV(csv, filename);
                  that.setState({
                        underlyingData:keyValuesData
                  })

          });

    }
  }

  showData(showData) {
    console.log("abccccc")
    console.log(showData)
  }
  toggleNewUserUpload(e){
    this.setState({
        user_upload: true
    })
    // Call the getUnderlyingDataAsync method on the viz object
    var that = this;
    if (this.viz) {
         var keyValuesData = [];
         var sheet = this.viz.getWorkbook().getActiveSheet().getWorksheets().get("Storm Map Sheet");
	       // If the active sheet is not a dashboard, then you can just enter:
	       // viz.getWorkbook().getActiveSheet();
         var options = {
            maxRows: 10, // Max rows to return. Use 0 to return all rows
            ignoreAliases: true,
            ignoreSelection: true,
            includeAllColumns: false
          };
          console.log(sheet);
          sheet.getUnderlyingDataAsync(options).then(function(t){

              var columns = t.getColumns();
              var dataRows = t.getData();

              console.log(columns);
              console.log(dataRows);
                 for (var i = 0; i < dataRows.length; i++) {
                      var row = dataRows[i];
                      var keyValueRow = {};
                      for (var j = 0; j < columns.length; j++) {
                        var fieldName = columns[j].getFieldName();
                        var fieldValue = row[j].value;
                        keyValueRow[fieldName] = fieldValue;
                      }
                      keyValuesData.push(keyValueRow);
                    }
                    console.log("abck", keyValuesData);
                    that.setState({
                        underlyingData:keyValuesData
                    })

          });

    }

    }

    handleFirstInteractive = () => {

    this.viz.addEventListener(

      tableau.TableauEventName.MARKS_SELECTION,
      this.handleMarksSelection,

    );
  };
  getFilterValues = (event) => { alert("getFilterValues");
//     var sheet_filter = this.viz.getWorkbook().getActiveSheet().getWorksheets().get("Visit-Organization");
//     sheet_filter.getFiltersAsync().then(filters => {
//       console.log("dateeeee");
//       console.log(filters);
//       var dateFilter = filters[0];
//       console.log(dateFilter);
//       const dateRangeValues = dateFilter.getAppliedValues();
//         console.log(dateRangeValues);
//       });
  };

  handleMarksSelection = (event) => {  alert("markselection");
    const worksheetName = event.getWorksheet().getName();
    const selectedMarks = event.getMarksAsync().then((marksArray) => {
      this.setState((prevState) => ({
        selectedMarksData: {
          ...prevState.selectedMarksData,
          [worksheetName]: marksArray,
        },
      }));
    });
  };

  renderMarksTable = (worksheetName, marksArray) => {
    return (
      <div key={worksheetName}>
        <h3>{worksheetName}</h3>
        <table border="1">
          <thead>
            <tr>
              {marksArray.length > 0 &&
                marksArray[0].getPairs().map((pair, colIndex) => (
                  <th key={colIndex}>{pair.fieldName}</th>
                ))}
            </tr>
          </thead>
          <tbody>
            {marksArray.map((mark, index) => (
              <tr key={index}>
                {Object.values(mark.getPairs()).map((value, colIndex) => (
                  <td key={colIndex}>{value.value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  render() {
    const { selectedMarksData } = this.state;
    const sheetNames = Object.keys(selectedMarksData);
    console.log(sheetNames);
    console.log("underlyingData state")
    console.log(this.state.underlyingData);
    let cardLists = this.state.underlyingData.map((underlying_data, index) => {
        return (
            <li key={index + 1}>{underlying_data["Storm Name"]}</li>
        )
    });
    return (
      <div>
      <p>{this.state.customers_count} Selected Customers</p>
        {/* The container for the Tableau visualization */}
        <button onClick={() => this.exportToPDF()}>Export PDF</button>
        <button onClick={() => this.exportToCSV()}>Export CSV</button>
        <button onClick={() => this.exportData()}>Export Data</button>
        <button onClick={() => this.showDownloadDialog()}>Show Download Dialog</button>
        <button onClick={this.getUnderlyingData.bind(this)}>Get Underlying Data</button>
        <button onClick={this.toggleNewUserUpload.bind(this)}>Action Console</button>
        <div id="tableauViz"></div>
         <div>

        <div>
          <h2>Selected Marks Data</h2>
          {sheetNames.map((worksheetName) =>
            this.renderMarksTable(worksheetName, selectedMarksData[worksheetName])
          )}
        </div>
      </div>

        <ul>
        {cardLists}
        </ul>

      </div>
    );
  }
}

export default TableauEmbed1;


// activeSheet.getUnderlyingDataAsync().then(function (dataTable) {
//     // Convert the DataTable to key-value format
//     var keyValuesData = [];
//     var columns = dataTable.getColumns();
//     var dataRows = dataTable.getData();
//
//     for (var i = 0; i < dataRows.length; i++) {
//       var row = dataRows[i];
//       var keyValueRow = {};
//
//       for (var j = 0; j < columns.length; j++) {
//         var fieldName = columns[j].getFieldName();
//         var fieldValue = row[j].value;
//
//         keyValueRow[fieldName] = fieldValue;
//       }
//
//       keyValuesData.push(keyValueRow);
//     }
//
//     // Now you have the data in key-value format in the keyValuesData array
//     console.log(keyValuesData);
//   });
// });




